import { render } from "./BankMenuView.vue?vue&type=template&id=784d1366"
import script from "./BankMenuView.vue?vue&type=script&lang=js"
export * from "./BankMenuView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__